import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { GaleriaService } from "../../providers/galeria.service";
import { EditarImagenGaleriaComponent } from "./editar-imagen-galeria/editar-imagen-galeria.component";
import { EditarImagenGaleriaDialog } from "./editar-imagen-galeria/editar-imagen-galeria-dialog/editar-imagen-galeria-dialog.component";
import { EliminarImagenGaleriaComponent } from "./eliminar-imagen-galeria/eliminar-imagen-galeria.component";
import { EliminarImagenGaleriaDialog } from "./eliminar-imagen-galeria/eliminar-imagen-galeria-dialog/eliminar-imagen-galeria-dialog.component";
import { OrdenGaleriaComponent } from "./orden-galeria/orden-galeria.component";
import { SubirImagenesGaleriaComponent } from "./subir-imagenes-galeria/subir-imagenes-galeria.component";
import { SubirImagenesGaleriaDialog } from "./subir-imagenes-galeria/subir-imagenes-galeria-dialog/subir-imagenes-galeria-dialog.component";
import { SubirVideoGaleriaComponent } from "./subir-video-galeria/subir-video-galeria.component";
import { SubirVideoGaleriaDialog } from "./subir-video-galeria/subir-video-galeria-dialog/subir-video-galeria-dialog.component";
import { ImageUploadModule } from "../../components/archivos/image-upload.module";
import { VerGaleriaComponent } from "./ver-galeria/ver-galeria.component";
import { ImageService } from "../../components/archivos/image-upload/image.service";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        ImageUploadModule,
    ],
    declarations: [
        EditarImagenGaleriaComponent,
        EditarImagenGaleriaDialog,
        EliminarImagenGaleriaComponent,
        EliminarImagenGaleriaDialog,
        OrdenGaleriaComponent,
        SubirImagenesGaleriaComponent,
        SubirImagenesGaleriaDialog,
        SubirVideoGaleriaComponent,
        SubirVideoGaleriaDialog,
        VerGaleriaComponent,
    ],
    providers: [
        GaleriaService,
        ImageService,
    ],
    entryComponents: [
        EditarImagenGaleriaDialog,
        EliminarImagenGaleriaDialog,
        SubirImagenesGaleriaDialog,
        SubirVideoGaleriaDialog,
    ],
    exports: [
        EditarImagenGaleriaComponent,
        EliminarImagenGaleriaComponent,
        OrdenGaleriaComponent,
        SubirImagenesGaleriaComponent,
        SubirVideoGaleriaComponent,
        VerGaleriaComponent,
    ]
})
export class GaleriaComponentModule { }